var map = {
	"./add.svg": "1ebb",
	"./answered.svg": "434d",
	"./arrow-left.svg": "931e",
	"./arrow-no-tail.svg": "7de2",
	"./arrow-tail.svg": "52f5",
	"./arrow.svg": "33a42",
	"./banned.svg": "5969",
	"./bill.svg": "be0d",
	"./blink.svg": "627e",
	"./brainstorm-white.svg": "9cc6",
	"./brainstorm.svg": "6a08",
	"./chat-canvas-noti.svg": "ba21",
	"./chat-canvas.svg": "d2ca",
	"./chat.svg": "4022",
	"./check.svg": "fbf4",
	"./chevron-right.svg": "ffbd",
	"./circle-check-with-border.svg": "9d88",
	"./circle-check.svg": "913b",
	"./clear.svg": "91f9",
	"./close.svg": "5765",
	"./cloud-import.svg": "6eb4",
	"./cloud.svg": "805a",
	"./coin.svg": "8dcd",
	"./community.svg": "6fad",
	"./copy-to-another-slide.svg": "a14d",
	"./copy.svg": "8a3d",
	"./correct-order-w.svg": "fbb2",
	"./correct-order.svg": "9250",
	"./correct.svg": "4529",
	"./default-thumbnail.svg": "4871",
	"./delete.svg": "1822",
	"./dislike.svg": "7281",
	"./document-w.svg": "d5d1",
	"./document.svg": "98f2",
	"./donut-w.svg": "22d9",
	"./donut.svg": "d944",
	"./download.svg": "5bd5",
	"./duplicated.svg": "2671",
	"./edit.svg": "9461",
	"./export.svg": "a858",
	"./fb.svg": "683c",
	"./file.svg": "dd2a",
	"./folder.svg": "b09e",
	"./gg.svg": "13f9",
	"./google-slides-w.svg": "8182",
	"./google-slides.svg": "6ee4",
	"./grid-4-dots.svg": "5aaa",
	"./grid-9-dots.svg": "300c",
	"./grid-w.svg": "bd51",
	"./guess-number.svg": "c5846",
	"./hamburger-menu.svg": "c06f",
	"./heading-w.svg": "ed43",
	"./heading.svg": "092f",
	"./heart.svg": "479e",
	"./hide.svg": "7b2e",
	"./idea.svg": "abaf",
	"./image-choice-w.svg": "f7e4",
	"./image-choice.svg": "bb69",
	"./image-w.svg": "bbde",
	"./image.svg": "7df8",
	"./import.svg": "4bab",
	"./inb.svg": "9484",
	"./incorrect.svg": "879b",
	"./info-circle.svg": "4cc1",
	"./information.svg": "2231",
	"./inspiration.svg": "3d8f",
	"./invite.svg": "bcb1",
	"./kebab-menu.svg": "6b850",
	"./key.svg": "0d1c",
	"./laugh.svg": "2cb6",
	"./laught.svg": "86b9",
	"./lightbulb.svg": "a88a",
	"./like.svg": "78e8",
	"./list-type.svg": "809a",
	"./list-w.svg": "31bc",
	"./list.svg": "b681",
	"./lock.svg": "1413",
	"./logo-icon-only.svg": "8522",
	"./logo.svg": "a6bb",
	"./logout.svg": "eacf",
	"./mail.svg": "4451",
	"./match-pairs-w.svg": "8697",
	"./match-pairs.svg": "a5cc",
	"./minus.svg": "7aa1",
	"./move.svg": "c5ee",
	"./multiple-choice-w.svg": "db8c",
	"./multiple-choice.svg": "1a89",
	"./music-note.svg": "eafd",
	"./name.svg": "a2df",
	"./no-presentation.svg": "1f08",
	"./no-result.svg": "f851",
	"./note.svg": "62bd",
	"./one-by-one-w.svg": "74b1",
	"./one-by-one.svg": "962c",
	"./open-ended-w.svg": "4160",
	"./open-ended.svg": "3dd6",
	"./open-new-window.svg": "be7d",
	"./pause.svg": "e3f7",
	"./payment.svg": "c878",
	"./pending.svg": "36dd",
	"./people.svg": "854e",
	"./phone.svg": "d7f5",
	"./pick-answer-w.svg": "3204",
	"./pick-answer.svg": "500a",
	"./pick-image-w.svg": "1576",
	"./pick-image.svg": "20f2",
	"./piechart-w.svg": "831b",
	"./piechart.svg": "fd3b",
	"./play.svg": "9d85",
	"./polygon.svg": "d36c",
	"./presentation.svg": "502b",
	"./presenter.svg": "41e3",
	"./profile.svg": "c022",
	"./q&a-w.svg": "e3cd",
	"./qa.svg": "0f4b",
	"./qr-code-w.svg": "07c9",
	"./qr-code.svg": "25e5",
	"./question.svg": "8d06",
	"./remove.svg": "bafd",
	"./replay.svg": "ad34",
	"./reposition.svg": "4e01",
	"./reset.svg": "6186",
	"./sad.svg": "c313",
	"./scales-w.svg": "8866",
	"./scales.svg": "9dbd",
	"./search.svg": "0c8d",
	"./send.svg": "6341",
	"./setting.svg": "d307",
	"./share-collab.svg": "157a",
	"./share.svg": "3eb8",
	"./shared-folder.svg": "184d",
	"./slides.svg": "5d75",
	"./spinner-wheel-bg-dark.svg": "2c40",
	"./spinner-wheel-bg-white.svg": "31ff",
	"./spinner-wheel-w.svg": "d68f",
	"./spinner-wheel.svg": "23df",
	"./spinner.svg": "0848",
	"./template.svg": "b823",
	"./tutorial.svg": "7c34",
	"./type-answer-w.svg": "d6bc",
	"./type-answer.svg": "a5a7",
	"./type-image.svg": "c976",
	"./unhide.svg": "2347",
	"./user-solid.svg": "f3ce",
	"./videos.svg": "dd61",
	"./whats-new.svg": "f220",
	"./whats-new_red.svg": "a51d",
	"./wheel-background.svg": "6338",
	"./white-logo.svg": "014c",
	"./word-cloud-w.svg": "5915",
	"./word-cloud.svg": "a813",
	"./wow.svg": "a910",
	"./youtube-w.svg": "ba3b",
	"./youtube.svg": "30d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b9a";